import { PersonAdd as PersonAddIcon } from '@mui/icons-material';
import {
  Alert,
  Avatar,
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  TextField,
  Typography
} from '@mui/material';
import React, { useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { register } from '../services/authService';

function Register({ setIsAuthenticated }) {
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Şifre kontrolü
    if (password !== confirmPassword) {
      setError('Şifreler eşleşmiyor.');
      return;
    }

    // Telefon numarası kontrolü
    const phoneRegex = /^05[0-9]{9}$/;
    if (!phoneRegex.test(phoneNumber)) {
      setError('Geçersiz telefon numarası formatı. Örnek: 05XXXXXXXXX');
      return;
    }

    setLoading(true);

    try {
      console.log('Kayıt olmaya çalışılıyor:', { username, email, password, phoneNumber });

      // Kayıt ol
      const success = await register(username, email, password, phoneNumber);

      if (success) {
        setIsAuthenticated(true);
        navigate('/dashboard');
      } else {
        setError('Kayıt başarılı ancak giriş yapılamadı. Lütfen giriş sayfasından tekrar deneyin.');
        navigate('/login');
      }
    } catch (error) {
      console.error('Register error:', error);

      // Hata mesajını göster
      if (error.response?.data?.detail) {
        const detail = error.response.data.detail;

        // Eğer detail bir array ise (FastAPI validation errors)
        if (Array.isArray(detail)) {
          const errorMessages = detail.map(err => {
            const field = err.loc ? err.loc.join('.') : 'Alan';
            return `${field}: ${err.msg}`;
          });
          setError(errorMessages.join('; '));
        }
        // Eğer detail bir obje ise (ama array değil)
        else if (typeof detail === 'object' && detail !== null) {
          setError(detail.msg || 'Kayıt olurken bir hata oluştu. Lütfen tekrar deneyin.');
        }
        // Eğer detail bir string ise
        else {
          setError(detail);
        }
      } else if (error.message) {
        setError(error.message);
      } else {
        setError('Kayıt olurken bir hata oluştu. Lütfen tekrar deneyin.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
            <PersonAddIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Helpigo'ya Kayıt Ol
          </Typography>
          {error && (
            <Alert severity="error" sx={{ mt: 2, width: '100%' }}>
              {error}
            </Alert>
          )}
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="username"
              label="Kullanıcı Adı"
              name="username"
              autoComplete="username"
              autoFocus
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="E-posta Adresi"
              name="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              id="phoneNumber"
              label="Telefon Numarası"
              name="phoneNumber"
              autoComplete="tel"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="05XXXXXXXXX"
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Şifre"
              type="password"
              id="password"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="confirmPassword"
              label="Şifreyi Tekrarla"
              type="password"
              id="confirmPassword"
              autoComplete="new-password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2, color: 'white' }}
              disabled={loading}
            >
              {loading ? 'Kayıt Olunuyor...' : 'Kayıt Ol'}
            </Button>
            <Grid container justifyContent="flex-end">
              <Grid item>
                <Link component={RouterLink} to="/login" variant="body2">
                  Zaten hesabınız var mı? Giriş yapın
                </Link>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}

export default Register; 